import { IApplicationState } from '../../../types/types';

export const getListCardIds = (
    state: IApplicationState,
    listId: number
): number[] => {
    return state.model.lists[listId] && state.model.lists[listId].cardIds || []
};
